import BoltRoundedIcon from '@mui/icons-material/BoltRounded';
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import BarChartRoundedIcon from '@mui/icons-material/BarChartRounded';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import { MOBILE_LISTS } from './mobileLists';
import { REPORT_SECTIONS } from './screens/reportViews/reportConfig';

// Client-only paths for the areas that are not desktop pages.
export const MOBILE_REPORT_PATH = '/mobileReport';
export const MOBILE_MENU_PATH = '/mobileMenu';

// The 5-tab bottom navigation (see MOBILE_PLAN.md §C). `labelKey` resolves via
// useTranslate; `Icon` is a MUI icon component.
//
// `pages` are the route keys an area gathers: it shows when the user holds one
// of them, and opens at the first one held, at the address the server gives it
// (see useMobileNavigation). An area with a `path` of its own is not a desktop
// page and opens there; Menu gathers nothing, so it always shows.
export const MOBILE_TABS = [
  {
    key: 'PRIORITIES',
    pages: ['PRIORITIES'],
    labelKey: 'PRIORITIES',
    Icon: BoltRoundedIcon,
  },
  {
    key: 'CUSTOMERS',
    pages: MOBILE_LISTS.map(({ key }) => key),
    labelKey: 'CUSTOMERS',
    Icon: PeopleAltRoundedIcon,
  },
  {
    key: 'APPOINTMENT',
    pages: ['APPOINTMENT'],
    labelKey: 'AGENDA',
    Icon: CalendarMonthRoundedIcon,
  },
  {
    key: 'REPORT',
    pages: REPORT_SECTIONS,
    path: MOBILE_REPORT_PATH,
    labelKey: 'REPORT',
    Icon: BarChartRoundedIcon,
  },
  {
    key: 'MENU',
    path: MOBILE_MENU_PATH,
    labelKey: 'MENU',
    Icon: MenuRoundedIcon,
  },
];
